var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('chat-content',{attrs:{"chats":_vm.chats,"chatProfile":_vm.chat_profile}})}
var staticRenderFns = []

export { render, staticRenderFns }